'use strict';

var React = require('react');

var SvgSmileyJoyIcon = function SvgSmileyJoyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.28 6.97a.75.75 0 0 0-1.06 0l-1 1a.75.75 0 0 0 1.06 1.06l.47-.47.47.47a.75.75 0 0 0 1.06-1.06l-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.72 6.97a.75.75 0 0 1 1.06 0l1 1a.75.75 0 0 1-1.06 1.06l-.47-.47-.47.47a.75.75 0 1 1-1.06-1.06l1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.876 10.99c.136-.536-.324-.99-.876-.99h-6c-.552 0-1.012.454-.876.99a4 4 0 0 0 7.752 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
  }));
};
SvgSmileyJoyIcon.displayName = "SmileyJoyIcon";

exports.SvgSmileyJoyIcon = SvgSmileyJoyIcon;
